import { callApi, ThrowError } from '@/api/callApi';
import { API_ENDPOINT, API_URL_CMS_SERVICE } from '@/api/constant';
import DragDropList from '@/components/common/commonTable/DragDropList';
import Card from '@/components/UI/Card';
import { IAppLayout } from '@/interfaces/appLayout.interface';
import { useState } from 'react';

interface Props {
  data: IAppLayout[];
  onSuccess: () => void;
  isLoading: boolean;
}

const AppLayoutOrder: React.FC<Props> = ({ data, onSuccess, isLoading }) => {
  const [listData, setListData] = useState(data);
  const callUpdateApi = async () => {
    try {
      const PATH = `${API_URL_CMS_SERVICE}${API_ENDPOINT.homeLayout}`;
      await callApi(PATH, {
        method: 'PUT',
        data: { sections: listData },
      });
      onSuccess();
    } catch (error) {
      ThrowError(error);
    }
  };

  const setOrder = (items: IAppLayout[]) => {
    setListData(
      items.map((item, index) => ({
        ...item,
        rank: index + 1,
      })),
    );
  };

  return (
    <Card>
      <DragDropList
        title="Primary Layout"
        data={listData}
        isLoading={isLoading}
        getId={(item) => item.id}
        renderItem={(item) => (
          <div
            key={item.id}
            className="flex items-center p-2 justify-between gap-3 w-full"
          >
            <span>{item.title}</span>
            <span>{item.rank}</span>
          </div>
        )}
        onReorder={setOrder}
        onSave={callUpdateApi}
      />
    </Card>
  );
};

export default AppLayoutOrder;
